import {ActionType} from '@ant-design/pro-table';
import React from 'react';

export const CommonManagerContext = React.createContext<{
  actionType?: React.MutableRefObject<ActionType | undefined>;
}>({});
